import { InjectionToken } from '@angular/core';
import type { Observable } from 'rxjs';

import { createEnumCodec } from '@dmb/core';

import type { ItemTableConfig } from '../widget/item-table-config';
import type { Dashboard } from './dashboard';

export enum DashboardWidgetName {
  News = 'News',
  UpcomingReleases = 'UpcomingReleases',
  QualityCheck = 'QualityCheck',
  ProductIncomplete = 'ProductIncomplete',
  LastSeen = 'LastSeen',
  ChartEntries = 'ChartEntries',
  ImportedRecently = 'ImportedRecently',
  ImportErrors = 'ImportErrors',
  TicketProducts = 'TicketProducts',
  TicketFixed = 'TicketFixed',
  Playlisted = 'Playlisted',
  Unplaylisted = 'Unplaylisted',
  PlaylistClimbers = 'PlaylistClimbers',
  PlaylistFallers = 'PlaylistFallers',
  TrendReportStreams = 'TrendReportStreams',
  TrendReportDownloads = 'TrendReportDownloads',
  Royalties = 'Royalties',
  PhysicalSaleIn = 'PhysicalSaleIn',
  PhysicalInStore = 'PhysicalInStore',
  ProjectsQC = 'ProjectsQC',
}

export type WidgetName = keyof typeof DashboardWidgetName;
export const DashboardWidgetNameC = createEnumCodec<DashboardWidgetName>(DashboardWidgetName, 'DashboardWidgetName');
export const uncapitalizeWN = (name: DashboardWidgetName): Uncapitalize<DashboardWidgetName> => {
  return (name[0].toLocaleLowerCase() + name.slice(1)) as Uncapitalize<DashboardWidgetName>;
};

export const WIDGET_NAME = new InjectionToken<string>('dmb-widget-name');
export const WIDGET = new InjectionToken<Observable<Dashboard[DashboardWidgetName]>>('dmb-widget');
export const TABLE_CONFIG = new InjectionToken<ItemTableConfig<object>>('dmb-table-config');
